import { useContext } from 'react';

import { AuthActionsContext, AuthStateContext } from './AuthContext';

const useAuth = () => {
  const user = useContext(AuthStateContext);
  const actions = useContext(AuthActionsContext);

  if (!actions) {
    throw new Error('useAuth must be used within an AuthProvider');
  }

  return { user, ...actions };
};

export { useAuth };
